export const IS_VERBOSE = process.env.NEXT_PUBLIC_VERBOSE === 'true'
